import { withPopup } from '../lib/popup';

import GroupBrandsStep from './GroupBrandsStep';

export default withPopup(GroupBrandsStep);
